<template>

    <div>

		<!-- page-heading -->
		<page-heading pageTitle="PIM-PRODUCT_GROUPS-HEADER"></page-heading>

		<div class="columns">

			<div class="col-main">

                <loading-indicator :loading="isLoading"></loading-indicator>

                <v-client-table
                    v-if="!isLoading"
                    ref="pimCampaignsTable"
                    name="pimCampaignsTable"
                    class="tbl-campaigns"
                    :data="productGroups"
                    :columns="tblColumns"
                    :options="table.tblOptions">

                    <template slot="productsCount" slot-scope="props">
                        {{ props.row.productsCount }}
                    </template>

                    <template slot="groupsCount" slot-scope="props">
                        {{ props.row.groupsCount }}
                    </template>

                    <template slot="updated" slot-scope="props">
                        {{ formatDate2(props.row.updated )}}
                    </template>

                    <template slot="actions" slot-scope="props">

                        <span class="button is-small" title="Gruppe bearbeiten">
                            <span class="icon is-small" @click.prevent="groupEdit(props.row)">
                                <i class="icon-ak-bearbeiten"></i>
                            </span>
                        </span>

                        <pop-confirm
                            class="button is-small"
                            content="Sind Sie sicher, dass Sie diese Gruppe entfernen möchten?"
                            icon="question-circle-o"
                            :on-ok="function() { groupDelete(props.row.id) }"
                            cancel-text="nein">

                            <span class="icon is-small" title="Aktion löschen">
                                <i class="icon-ak-entfernen"></i>
                            </span>

                        </pop-confirm>

                    </template>

                </v-client-table>

            </div>

            <div class="col-aside">

                <affix :offset="50">

                    <custom-button icon="icon-ak-hinzufuegen" name="PIM-PRODUCT_GROUPS-BTN-NEW_GROUP" type="blue" @click.native="groupNew"></custom-button>

                </affix>

            </div>

        </div>

    </div>

</template>

<script>
import Vue from 'vue';

import { ClientTable, Event} from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');


export default {

    data () {
        return {


            isLoading: true,
            productGroups: null,

            table: {

                tblOptions: {
                    uniqueKey: 'id',
					saveState: false,
					perPage: 25,

					orderBy: {
						ascending: false,
						column: 'updated'
					},

                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    headings: {

                        name(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUPS-TABLE_HEADING-NAME"></lang>
                        },
                        description(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUPS-TABLE_HEADING-DESCRIPTION"></lang>
                        },
                        productsCount(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUPS-TABLE_HEADING-PRODUCT_COUNT"></lang>
                        },
                        groupsCount(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUPS-TABLE_HEADING-GROUPS_COUNT"></lang>
                        },
                        updated(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUPS-TABLE_HEADING-UPDATED"></lang>
                        },
                        actions(h) {
                            return "";
                        },
                    },

                    sortable: ['type', 'source', 'status', 'validFrom', 'validTo', 'status', 'productsCount', 'groupsCount', 'voucherCode'],

                    texts: {
                        first:'Anfang',
                        last:'Ende',
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag',
                        loading: 'Lade Daten ...'
                    },

                    pagination: {
                        dropdown: false,
                        chunk: 5,
                        edge: false
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [

					],

                    filterable: false,
                    columnsClasses: {
                        'actions': 'actions'
                    },
                }
            },

        }
    },

    computed: {

        tblColumns() {
            return ['name', 'description', 'productsCount', 'groupsCount', 'updated', 'actions'];
        },

        siteId() {
            return this.activeUser.site == null ? null : this.activeUser.site.id;
        }

    },

    created() {

        this.fetchData();

    },

    methods: {

        groupNew() {

            this.$router.push({name: 'pimProductGroupsNew'});

        },

        groupEdit(row) {

            this.$router.push({ name: 'pimProductGroupsDetail', params: { id: row.id }});

        },

        groupDelete(id) {

            this.axios.delete(this.$config.api + 'apopointProductGroup/'+id).then(res => {

                let foundIndex = this.productGroups.findIndex(g => g.id == id);
                if(foundIndex != -1) {
                    this.productGroups.splice(foundIndex, 1);
                }

                this.$notify.open({ content: 'Gruppe wurde erfolgreich entfernt!', type: 'success'});


            })

        },

        fetchData() {

            this.isLoading = true;

            this.axios.get(this.$config.api + 'apopointProductGroup?include=apopointProductGroup.offers,apopointProductGroup.products&showMetafields=1&filters[site]='+this.siteId).then(res => {

                res.data.apopointProductGroup.forEach(g => {
                    g.productsCount = g.products.length;
                    g.groupsCount = g.offers.length;
                })

                this.productGroups = res.data.apopointProductGroup;

                setTimeout(() => this.isLoading = false, 500);
            })

        }
    }

}
</script>

<style lang="scss" scoped>

    ::v-deep .VueTables__table {

        td.actions {

            text-align: right;

            .button {
                .icon {
                    margin: 0 !important;
                    font-size: 12px;
                }
                &:first-child {
                    margin-right: 4px;
                }
            }

        }
    }

</style>
